import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  wrapperPropretyDetails: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    padding: "24px",
  },
  divider: {
    marginTop: "20px",
  },
  containerInfoDetails: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  containerDataItem: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: "16px",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
}));
